/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_New_Source_AddInputs */

const vi_pll_new_source_add = /** @type {(inputs: Pll_New_Source_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm lô nguồn`)
};

/**

* @param {Pll_New_Source_AddInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_new_source_add = /** @type {((inputs?: Pll_New_Source_AddInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_New_Source_AddInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_new_source_add(inputs)
});